import {event} from '../modules/event';
import {scriptonload} from '../modules/scriptonload';
import {PopupForm} from '../modules/PopupForm';
import {Transform} from '../modules/Transform';

var Avatar = class {
    constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvents();
    }

    _createElements(wrapper){
        var self = this;
        this.wrapper = wrapper;
        this.popupFormObj = new PopupForm({
            wrapper: this.wrapper,
            onsuccess: function(data){
                self._showLoadedPhoto.call(self, data);
                return false;
            },
            onerror: function(data){
                uPopup({
                    content:data.message,
                    onclose:function(){
                        self.form.className = 'avatarChange';
                    }
                });
                return false;
            },
            beforeShowPopup:function(){
                self.form.className = 'avatarChange';
            }
        });

        this.form = this.wrapper.querySelector('[data-Avatar-form]');

        this.curBox = this.form.querySelector('[data-Avatar-curBox]');
        this.avatarImage = this.curBox.querySelector('[data-Avatar-image]');
        this.file = this.curBox.querySelector('[data-Avatar-file]');

        this.loadedBox = this.form.querySelector('[data-Avatar-loadedBox]');
        this.transform = this.loadedBox.querySelector('[data-Avatar-transform]');
        this.loadingFrame = this.loadedBox.querySelector('[data-Avatar-loadingFrame]');
        this.transformObj = new Transform(this.transform);
        this.readyBtn = this.loadedBox.querySelector('[data-Avatar-ready]');

        this.hiddens={};
        this.hiddens.uploadedField = this.form.querySelector('[data-Avatar-uploadedField]');
        this.hiddens.areaField = this.form.querySelector('[data-Avatar-areaField]');
    }

    _addEvents(){
        var self = this;

        event.add(this.file, 'change', function(e){
            e.preventDefault();
            self.hiddens.uploadedField.setAttribute('value', '');
            self.form.className = 'avatarChange js-loading';
            self.form.submit();
        });

        event.add(this.readyBtn, 'click', function(e){
            e.preventDefault();
            self.transformObj.getArea();
            self.hiddens.areaField.setAttribute('value', JSON.stringify(self.transformObj.area));
            self.popupFormObj.initData.onsuccess = function(data){
               self._showNewAvatar.call(self, data);
                return  true;
            }
            self.form.submit();
            self.form.className = 'avatarChange js-loading';
        });
    }

    _resetAvatarChange(){
        this.form.className = 'avatarChange';
    }

    _showLoadedPhoto(data){
        var self = this,
            image=document.createElement('img'),
            path = (window.location + '').indexOf('/_src/') === -1 ? '' : '../img/tmp/avatar/',
            pathUploaded = (window.location + '').indexOf('/_src/') === -1 ? '' : '../',
            src = path+data.name;

        image.className='avatarChange_loadingPhoto';
        image.onload=function(){

            self.loadingFrame.innerHTML = '';
            self.loadingFrame.appendChild(image);

            self.hiddens.uploadedField.setAttribute('value', pathUploaded+src);

            self.transformObj.reset();

            self.form.className = 'avatarChange js-loaded';
        }
        image.setAttribute('src', src);
    }

    _showNewAvatar(data){
        var self = this;
        var url = 'url('+ data.src + '?rnd=' + new Date().getTime() +')';

        /*
         * TODO
         * всего одна кнопка вызова аватарки - это сама аватарка в ЛК
         * если когда нить доавится еще - нужно предусматривать этот момент
         * и заменять аватарку только в нужной кнопке
          *
          * */
        for(var i=0, j=this.popupFormObj.btnAll.length; i<j; i++) {
            var btn = this.popupFormObj.btnAll[i];
            btn.style.backgroundImage = url;
            btn.innerHTML = ''; /* удаляем svg иконку, если не было аватарки */
        }

        this.avatarImage.style.backgroundImage = url;
        this.avatarImage.innerHTML = ''; /* удаляем svg иконку, если не было аватарки */
        this.hiddens.uploadedField.setAttribute('value', '');
        this.form.className = 'avatarChange';
        this.popupFormObj.initData.onsuccess = function(data){
            self._showLoadedPhoto.call(self, data);
            return false;
        }
    }


}

export {Avatar};










